import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { OverlayStackService } from '../overlay-stack.service';
import {
  OverlayStackItemKind,
  OverlayStackPlacement,
  OverlayStackPlacementValue,
  RenderedOverlayStackItem
} from '../overlay-stack-item';
import { ToastCardComponent } from './toast-card.component';
import { NotificationCardComponent } from './notification-card.component';

@Component({
  selector: 'loop-overlay-stack',
  templateUrl: './overlay-stack.component.html',
  styleUrls: ['./overlay-stack.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ToastCardComponent, NotificationCardComponent]
})
export class OverlayStackComponent {
  private readonly overlayStackService: OverlayStackService = inject(OverlayStackService);

  protected readonly itemKind: typeof OverlayStackItemKind = OverlayStackItemKind;

  protected readonly leftItems: Signal<RenderedOverlayStackItem[]> = this.itemsAt(OverlayStackPlacement.left);
  protected readonly rightItems: Signal<RenderedOverlayStackItem[]> = this.itemsAt(OverlayStackPlacement.right);
  protected readonly centerItems: Signal<RenderedOverlayStackItem[]> = this.itemsAt(OverlayStackPlacement.center);

  protected close(item: RenderedOverlayStackItem): void {
    this.overlayStackService.remove(item.id);
  }

  /** Hovering a toast holds its auto-dismissal; notifications run their countdowns undisturbed. */
  protected pauseTimer(item: RenderedOverlayStackItem): void {
    if (item.kind === OverlayStackItemKind.toast) {
      this.overlayStackService.pauseTimer(item.id);
    }
  }

  protected resumeTimer(item: RenderedOverlayStackItem): void {
    if (item.kind === OverlayStackItemKind.toast) {
      this.overlayStackService.resumeTimer(item.id);
    }
  }

  private itemsAt(placement: OverlayStackPlacementValue): Signal<RenderedOverlayStackItem[]> {
    return computed(() => this.overlayStackService.items().filter(item => item.placement === placement));
  }
}
